<ng-content></ng-content>
<ng-container *ngFor="let column of columns; trackBy: trackBy">
  <td
    [style.width.px]="column.width"
    [style.maxWidth.px]="column.width"
    [style.flexBasis.px]="column.width"
    [style.justifyContent]="column.footerAlign | columnAlignment"
    [attr.data-field]="column.field"
  >
    <ng-container *ngIf="(displayColumns$ | async).includes(column.field) && !(displayColumnsText$ | async).includes(column.field)">
      <ng-container *ngIf="column.formatter === 'money'">
        {{ (data$ | async)[column.field] | currency }}
      </ng-container>

      <ng-container *ngIf="column.formatter === 'decimal'">
        {{ (data$ | async)[column.field] | number : '1.0-4' }}
      </ng-container>

      <ng-container *ngIf="column.formatter === 'number'">
        {{ (data$ | async)[column.field] | number : '1.0-0' }}
      </ng-container>

      <ng-container *ngIf="!column.formatter">
        {{ (data$ | async)[column.field] | number : '1.0-0' }}
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(displayColumnsText$ | async).includes(column.field) && !(displayColumns$ | async).includes(column.field)">
      <ng-container *ngIf="!column.formatter">
        {{ (dataText$ | async)[column.field] }}
      </ng-container>
    </ng-container>
  </td>
</ng-container>
